import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { AgendaTypes } from "../../../utils/types/pagesTypes"

export const DOWNLOAD_REPORT = "downloadReport"

export const downloadReport = (reportAgenda: AgendaTypes, exportType: Maybe<"csv" | "excel">) => ({
    type: DOWNLOAD_REPORT,
    payload: {
        reportAgenda: reportAgenda,
        exportType: exportType,
    },
})

export const DOWNLOAD_REPORT_SUCCESS = "downloadReport/success"

export const downloadReportSuccess = () => ({
    type: DOWNLOAD_REPORT_SUCCESS,
})

export const DOWNLOAD_REPORT_FAILURE = "downloadReport/failure"

export const downloadReportFailure = (error: any) => ({
    type: DOWNLOAD_REPORT_FAILURE,
    payload: {
        error: error,
    },
})
